import {get} from "lodash"
import BaseService from "./Base"
import {
    PaymentsReconciliationListRequest,
    PaymentsReconciliationListResponse,
    ReprocessPaymentsReconciliationRowsRequest,
    ReprocessPaymentsReconciliationRowsResponse
} from "types/integrations/paymentsReconciliation"

class PaymentsReconciliationService extends BaseService {
    async listRows(params: PaymentsReconciliationListRequest): Promise<PaymentsReconciliationListResponse> {
        const response = await this.post("/v1/student-account/payments-reconciliation/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async reprocessRows(
        params: ReprocessPaymentsReconciliationRowsRequest
    ): Promise<ReprocessPaymentsReconciliationRowsResponse> {
        const response = await this.post("/v1/student-account/payments-reconciliation/reprocess", params)
        return get(response, "data", {
            success: false,
            data: {
                processedRows: 0,
                skippedRows: 0,
                failedRows: 0
            }
        })
    }
}

export default PaymentsReconciliationService
